import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The billing-cycle table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen, so a different
 * wording there reads as a different column.
 *
 * Two are locked. `resource` is the only thing that says which machine a row bills, and it is the
 * link to the resource; `actions` is where Edit lands on the expiry screen. `index` is NOT locked
 * here, unlike the payment table: this table carries no selection checkbox, so the column is a row
 * number and nothing else, and an operator short of width should be free to drop it.
 *
 * `order` sits next to `funding` on purpose: for a cycle funded by a payment, the order IS what
 * `funding` is pointing at, so the two read as one answer. It is the only column whose value does
 * not come from the billing-cycle response — the page resolves it from `sourceReferenceId` — and it
 * is blank by design on trial and transfer rows, whose funding reference is not an order.
 */
export const BILLING_CYCLE_COLUMNS = [
  { id: "index", label: "STT" },
  { id: "resource", label: "Resource", locked: true },
  { id: "status", label: "Status" },
  { id: "funding", label: "Funding" },
  { id: "order", label: "Order" },
  { id: "tenant", label: "Tenant" },
  { id: "user", label: "User" },
  { id: "period", label: "Period" },
  { id: "amount", label: "Amount" },
  { id: "renewal", label: "Renewal" },
  { id: "createdAt", label: "Created At" },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type BillingCycleColumnId = (typeof BILLING_CYCLE_COLUMNS)[number]["id"];

export const useBillingCycleColumnsStore =
  createColumnVisibilityStore<BillingCycleColumnId>({
    name: "admin.billing-cycles.columns",
    columns: BILLING_CYCLE_COLUMNS,
  });
